import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TierPageRoutingModule } from './tier-routing.module';

import { TierPage } from './tier.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TierPageRoutingModule,
    NgxDatatableModule
  ],
  declarations: [TierPage]
})
export class TierPageModule {}
